<template>
  <div class="wrapper">
    <Loading :active.sync="loading" :lock-scroll="true" :is-full-page="true" :opacity="0.7" color="#F58549"></Loading>

    <div class="wrapper fadeInDown" >
      <div v-if="!loading" id="formContent">

        <div class="fadeIn first">
          <img style="width: 12vw" src="../img/albinuta.png"/>
        </div>

        <v-form>
          <v-text-field
            id="name"
            v-model="name"
            style="margin: 0px 20px 0px 20px;"
            type="text"
            class="fadeIn"
            label="Nume"
            hint="Va fi folosit pentru diplome"
            ></v-text-field>

          <v-text-field
            v-model="email"
            style="margin: 5px 20px 5px 20px;"
            type="text"
            class="fadeIn"
            label="E-mail"
            ></v-text-field>

          <v-text-field
            v-model="pass"
            style="margin: 5px 20px 5px 20px;"
            :append-icon="showPass1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPass1 ? 'text' : 'password'"
            label="Parola"
            @click:append="showPass1 = !showPass1"
            @keyup.enter="submit()">
          </v-text-field>

          <v-text-field
            v-model="passConfirm"
            style="margin: 5px 20px 5px 20px;"
            :rules="[emailMatch]"
            :append-icon="showPass2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPass2 ? 'text' : 'password'"
            label="Confirmă parola"
            @click:append="showPass2 = !showPass2"
            @keyup.enter="submit()">
          </v-text-field>
        </v-form>

        <div class="container">
          <button
            type="button"
            class="buton btn"
            style="margin-right: 2vh;"
            @click="submit()">
            Creează cont
          </button>

          <button
            type="button"
            class="buton btn">
            <router-link style="text-decoration: none; color:black;" to="/">
              Înapoi
            </router-link>
          </button>
        </div>
      </div>

      <sweet-modal ref="alertVerifyMail" icon="success" @close="goToLogin()">
        <div style="margin-bottom: 2vh;">Contul a fost creat!</div>
        <div style="margin-bottom: 2vh;">Ți-am trimis un e-mail la {{email}}. Pentru a putea accesa contul trebuie să accesezi link-ul pe care îl conține.</div>
        <div style="margin-bottom: 2vh;">Nu uita să verifici și în Spam dacă nu îl găsești!</div>

        <div>
          <button type="button" class="buton btn" @click="goToLogin()">Am înțeles</button>
        </div>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios'

export default {
  components: {
    SweetModal,
    Loading
  },

  data: () => ({
    name: '',
    email: '',
    pass: '',
    passConfirm: '',
    errorMessage: '',
    showPass1: false,
    showPass2: false,
    loading: false
  }),

  methods: {
    submit () {
      if(this.name && this.email && this.pass && this.pass === this.passConfirm) {
        this.loading = true

        axios.post('/auth/signup', {
          name: this.name,
          email: this.email,
          password: this.pass
        }).then(() => {
          this.loading = false;
          this.$refs.alertVerifyMail.open()
        }).catch(error => {
          this.loading = false;
          if(error.response.status === 409) {
            alert("Adresa de e-mail este deja asociată unui cont")
          } else {
            alert('Ceva nu a mers bine')
            console.log(error)
          }
        })

        this.pass = ''
        this.passConfirm = ''

      } else {
        alert("Date completate incorect")
      }
    },

    goToLogin(){
      this.$router.replace({ name: 'login' })
    }
  },

  computed: {
    emailMatch() {
      if(this.pass !== this.passConfirm) {
        return "Parolele nu se potrivesc"
      }

      return true
    }
  }
}
</script>

<style scoped>

body {
  background-color: #F2A65A;
  height: 100vh;
}

.container {
  margin-top: 1vh;
  margin-bottom: 2vh;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #F58549;
}

/* Form Inputs */


/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* OTHERS */
*:focus {
    outline: none;
}

#icon {
  width:60%;
}

</style>
